'use strict';
/**
 * @author Maxim Seredkin
 */
import angular from "angular";
import AuditsController from "./controller/actionSelect";

export default angular.module('investmentProject.audit.action', [])
    .controller('ActionSelectController', AuditsController)
    .name;
